import { useSearchParams } from 'react-router-dom';

// Written by the Partner Portal "Create application" button; kept module-local because nothing
// outside this hook should read the URL directly (see the pinning note below).
const PARTNER_SOURCE_PARAM = 'source';
const PARTNER_SOURCE_VALUE = 'partner';
const PARTNER_USER_EMAIL_PARAM = 'partnerUserEmail';

type TPartnerInitiatedParams = {
	isPartnerInitiated: boolean;
	partnerUserEmail: string | null;
};

export const useIsPartnerInitiated = (): TPartnerInitiatedParams => {
	const [searchParams] = useSearchParams();

	return {
		isPartnerInitiated: searchParams.get(PARTNER_SOURCE_PARAM) === PARTNER_SOURCE_VALUE,
		partnerUserEmail: searchParams.get(PARTNER_USER_EMAIL_PARAM),
	};
};
